import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import TransactionPageComponent from './TransactionPageComponent';
import { push } from 'react-router-redux';

export const mapStateToProps = (state: AppState) => {
    return {
        returnTransactionId: state.payment.returnTransactionId,
        returnTransactionStatus: state.payment.returnTransactionStatus,
        paymentStatus: state.payment.paymentStatus,
        payuid: state.payment.txnid,
        txnamt: state.payment.txnamt,
        axperror: state.payment.axperror
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        // onComponentDidMount: () => {
        // dispatch(clearSession);
        // }
        goBack: (location: string) => {
            if (location === 'home') {
                dispatch(push('/app'));
            } else if (location === 'payment') {
                dispatch(push('/app/paymentinvoices'));
            }
        }
    };
};

const TransactionPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(TransactionPageComponent);

export default TransactionPageContainer;



// WEBPACK FOOTER //
// ./src/components/TransactionPage/TransactionPageContainer.tsx